const METRICS = [
  { name: 'PRODUCTION.REAL_TIME.METRIC_TURNOVER', key: 'turnover' },
  { name: 'PRODUCTION.REAL_TIME.METRIC_UNIT', key: 'unit' },
];

export default METRICS;
